import Env from '../base/env';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
import { SplitText } from '../vendor/gsap-bonus-umd/SplitText';
gsap.registerPlugin(ScrollTrigger,SplitText);

function detectOffsetStart(el)
{
  let offsetStart
  if(typeof el.getAttribute('data-start') != 'undefined') {
    offsetStart = el.getAttribute('data-start')
  }
  if(Env.mobileCSS && typeof el.getAttribute('data-start-mobile') != 'undefined') {
    offsetStart = el.getAttribute('data-start-mobile')
  }
  return offsetStart;
}

export function animationText(settings)
{
  //!
  let FX = {}
  FX.text = new SplitText(settings.text, { type:'chars' })

  const tlFadetext = gsap.timeline({
    scrollTrigger:{
      trigger:settings.trigger,
      start:'top bottom',
      end:'bottom bottom',
      markers:false,
      scrub:1.5
    }
  })

  tlFadetext
  .add([
    gsap.fromTo(
      FX.text.chars,
      {
        autoAlpha:.3
      },
      {
        autoAlpha:1,
        ease:'cubic.inOut',
        duration:3,
        stagger:.1
      }
    )
  ])
}

export function animationReveal(settings)
{
  const tlReveal = gsap.timeline({
    scrollTrigger:{
      trigger:settings.trigger,
      start:'top 60%',
      end:'+=800px',
      scrub:1
    }
  })

  tlReveal
  .add([
    gsap.fromTo(
      settings.DomToReveal,
      {
        autoAlpha:0
      },
      {
        autoAlpha:1,
        ease:'cubic.out',
        duration:1
      }
    )
  ])
}

export function RevealFadeY(el)
{
  let offsetStart = (Env.mobileCSS)?'top 90%':'top 50%';
  offsetStart = detectOffsetStart(el)
  console.log(offsetStart);
  let delayFx = (typeof el.getAttribute('data-delay') != undefined)?el.getAttribute('data-delay'):0;

  gsap.fromTo(
    el,
    {
      autoAlpha:0,
      y:50
    },
    {
      autoAlpha:1,
      y:0,
      duration:1.5,
      ease:'quint.out',
      delay:delayFx*1,
      onStart:()=>{
        el.classList.add('is-animated')
      },
      scrollTrigger: {
        trigger:el,
        start:offsetStart
      }
    }
  )
}

export function RevealFade(el)
{
  let offsetStart = (Env.mobileCSS)?'top 90%':'top 50%';
  offsetStart = detectOffsetStart(el)
  console.log(offsetStart);
  let delayFx = (typeof el.getAttribute('data-delay') != undefined)?el.getAttribute('data-delay'):0;

  gsap.fromTo(
    el,
    {
      autoAlpha:1,
    },
    {
      autoAlpha:0,
      duration:1.5,
      ease:'quint.out',
      delay:delayFx*1,
      onStart:()=>{
        el.classList.add('is-animated')
      },
      scrollTrigger: {
        trigger:el,
        start:offsetStart
      }
    }
  )
}
